import { useEffect } from "react";

/**
 * Prevents body scroll when a modal/overlay is open.
 * Restores the original overflow value on close or unmount.
 */
export function useScrollLock(isOpen: boolean) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);
}

/**
 * Closes a modal when the Escape key is pressed.
 * Only listens while `isOpen` is true.
 */
export function useEscapeKey(isOpen: boolean, onClose: () => void) {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                e.preventDefault();
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);
}
